export enum LoginActionTypes {
  LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED',
  LOGIN_FAILED = 'LOGIN_FAILED',
  LOGOUT_REQUEST = 'LOGOUT_REQUEST',
  LOGOUT_SUCCEEDED = 'LOGOUT_SUCCEEDED',
  LOGOUT_FAILED = 'LOGOUT_FAILED',
  SESSION_REQUEST = 'SESSION_REQUEST',
  UPDATE_ACCOUNT_REQUEST = 'UPDATE_ACCOUNT_REQUEST',
  UPDATE_ACCOUNT_SUCCEEDED = 'UPDATE_ACCOUNT_SUCCEEDED',
  UPDATE_ACCOUNT_FAILED = 'UPDATE_ACCOUNT_FAILED',
  CHANGE_USER_FLEET_REQUEST = 'CHANGE_USER_FLEET_REQUEST',
}
